<div class="dp-scope" role="group" aria-label="What is anonymized">
  <div class="custom-control custom-checkbox mb-1" *ngFor="let option of options">
    <input type="checkbox" class="custom-control-input" [id]="idPrefix + '-' + option.value"
           [checked]="isChecked(option)" [disabled]="disabled || option.locked"
           (change)="toggle(option, $any($event.target).checked)">
    <label class="custom-control-label" [for]="idPrefix + '-' + option.value">{{ option.label }}</label>
  </div>
</div>
